import { Box, HStack, Progress, Text } from '@chakra-ui/react'
import { useEffect, useMemo, useState } from 'react'
import { useThemeColors } from '@/hooks/useThemeColors'
import { getSlaStatus } from './slaUtils'

type Props = {
  slaDueAt: string | null | undefined
}

const toneStyles = {
  on_track: { scheme: 'green' as const, bg: 'green.50', color: 'green.700', border: 'green.200' },
  due_soon: { scheme: 'orange' as const, bg: 'orange.50', color: 'orange.700', border: 'orange.200' },
  overdue: { scheme: 'red' as const, bg: 'red.50', color: 'red.700', border: 'red.200' },
  none: { scheme: 'gray' as const, bg: 'gray.50', color: 'gray.600', border: 'gray.200' },
}

export default function SlaStatusStrip({ slaDueAt }: Props) {
  const colors = useThemeColors()
  const [now, setNow] = useState(Date.now())

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 60_000)
    return () => clearInterval(id)
  }, [])

  const sla = useMemo(() => getSlaStatus(slaDueAt, now), [slaDueAt, now])
  const tone = toneStyles[sla.urgency === 'none' ? 'none' : sla.urgency]

  return (
    <Box
      p={3}
      borderRadius="md"
      border="1px solid"
      borderColor={tone.border}
      bg={tone.bg}
    >
      <HStack justify="space-between" align="flex-start" gap={3} flexWrap="wrap">
        <Box minW={0}>
          <Text fontSize="xs" fontWeight="700" color={colors.textSecondary} textTransform="uppercase" mb={1}>
            SLA
          </Text>
          <Text fontSize="sm" fontWeight="700" color={tone.color}>
            {sla.label}
          </Text>
          {sla.detail ? (
            <Text fontSize="xs" color={colors.textMuted} mt={0.5}>
              {sla.detail}
            </Text>
          ) : null}
        </Box>
      </HStack>
      {sla.progressPercent != null && sla.urgency !== 'none' ? (
        <Progress
          value={sla.progressPercent}
          size="xs"
          colorScheme={tone.scheme}
          borderRadius="full"
          mt={2}
        />
      ) : null}
    </Box>
  )
}
